export const compose =
  (...params: CallableFunction[]) =>
  (init: any) =>
    params.reduce((acc, next) => next(acc), init);

export const isNullOrUndefined = (value: any): boolean => value === null || value === undefined;

export const isObject = (value: any) => typeof value === 'object';

export const isEmptyString = (str: any) => str === null || str === undefined || str.toString().trim().length === 0;

export const isEmptyObject = (obj: object = {}) => {
  for (const prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }
  return true;
};

export const capitalize = (value?: string) => (value ? `${value[0].toUpperCase()}${value.slice(1)}` : value);

export const delay = (millis: number = 1000, value?: any): Promise<any> =>
  // eslint-disable-next-line no-promise-executor-return
  new Promise(resolve => setTimeout(() => resolve(value), millis));

export const formatCurrency = (value?: number) => value && `$ ${new Intl.NumberFormat('de-DE').format(value)}`;

export const getBase64ByFile = async (file: File): Promise<any> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

export const redirect = (url: string) => {
  window.location.href = url;
};

export const groupBy = <T>(items: T[], callback: (item: T) => string): Record<string, T[]> =>
  items.reduce((acc, item) => {
    const id = callback(item);

    if (!acc[id]) {
      acc[id] = [];
    }

    acc[id].push(item);
    return acc;
  }, {} as Record<string, T[]>);

export const getByPath = <T>(path: string | string[], object: T = {} as T): any => {
  const paths = typeof path === 'string' ? path.split('.') : path;
  // @ts-ignore
  return paths.reduce((obj, name) => obj?.[name], object);
};

export const uuid = (): string => (new Date().getTime() * Math.random() * 100000).toString();
